/**
 * 디바이스 감지 및 최적화 유틸리티
 * 실무에서 많이 사용하는 모바일 최적화 기법
 */

/**
 * 모바일 디바이스 여부 확인
 */
export const isMobile = (): boolean => {
  // User Agent 기반 감지
  const userAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
  
  // 화면 크기 기반 감지 (더 정확)
  const isSmallScreen = window.innerWidth <= 768;
  
  return userAgent || isSmallScreen;
};

/**
 * 태블릿 여부 확인
 */
export const isTablet = (): boolean => {
  return /iPad|Android/i.test(navigator.userAgent) && 
         window.innerWidth > 768 && 
         window.innerWidth <= 1024;
};

/**
 * 데스크톱 여부 확인
 */
export const isDesktop = (): boolean => {
  return !isMobile() && !isTablet();
};

/**
 * 최적의 DPR (Device Pixel Ratio) 반환
 * 모바일에서는 성능을 위해 1로 제한
 */
export const getOptimalDPR = (): number => {
  if (isMobile()) {
    return 1; // 모바일에서는 항상 1
  }
  // 데스크톱에서는 최대 2로 제한 (고해상도 모니터 대응)
  return Math.min(window.devicePixelRatio || 1, 2);
};

/**
 * 파티클 수 최적화
 * 모바일에서는 기본값의 40%로 감소
 */
export const getOptimalParticleCount = (baseCount: number): number => {
  if (isMobile()) {
    return Math.floor(baseCount * 0.4);
  }
  return baseCount;
};

/**
 * 성능 등급 확인 (낮음/보통/높음)
 */
export const getPerformanceTier = (): 'low' | 'medium' | 'high' => {
  if (isMobile()) {
    // 모바일은 대부분 low 또는 medium
    const memory = (navigator as any).deviceMemory;
    if (memory && memory <= 2) {
      return 'low';
    }
    return 'medium';
  }
  return 'high';
};

